var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgInfoIcon = function SvgInfoIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99961,
    cy: 6.50001,
    r: 6.4,
    fill: "#929292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99883 9.7L6.99883 5.7",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99883 2.50001C6.557 2.50001 6.19883 2.85818 6.19883 3.30001C6.19883 3.74183 6.557 4.10001 6.99883 4.10001C7.44066 4.10001 7.79883 3.74183 7.79883 3.30001C7.79883 2.85818 7.44066 2.50001 6.99883 2.50001Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNi45OTk2MSIgY3k9IjYuNTAwMDEiIHI9IjYuNCIgZmlsbD0iIzkyOTI5MiIvPgo8cGF0aCBkPSJNNi45OTg4MyA5LjdMNi45OTg4MyA1LjciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi45OTg4MyAyLjUwMDAxQzYuNTU3IDIuNTAwMDEgNi4xOTg4MyAyLjg1ODE4IDYuMTk4ODMgMy4zMDAwMUM2LjE5ODgzIDMuNzQxODMgNi41NTcgNC4xMDAwMSA2Ljk5ODgzIDQuMTAwMDFDNy40NDA2NiA0LjEwMDAxIDcuNzk4ODMgMy43NDE4MyA3Ljc5ODgzIDMuMzAwMDFDNy43OTg4MyAyLjg1ODE4IDcuNDQwNjYgMi41MDAwMSA2Ljk5ODgzIDIuNTAwMDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";